import { render, staticRenderFns } from "./ListActivoPage.vue?vue&type=template&id=fff15522&scoped=true"
import script from "./ListActivoPage.vue?vue&type=script&lang=js"
export * from "./ListActivoPage.vue?vue&type=script&lang=js"
import style0 from "./ListActivoPage.vue?vue&type=style&index=0&id=fff15522&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fff15522",
  null
  
)

export default component.exports